import CreateTicketForm from '../../features/operation/forms/create';

// TSS vite/01 §"Pages are thin".
//
//   /admin/operation/tickets/new        registrar un reporte
//   /admin/operation/tickets/new?project=N   con el proyecto ya elegido
//
// El alta es una pantalla propia y no un modal sobre la lista: el cuerpo del
// reporte es un textarea de seis líneas y lo que se escribe ahí es lo único que
// después no se puede reconstruir. Un diálogo que se cierra con Escape no es el
// lugar para eso.

export default function TicketNewPage() {
    return <CreateTicketForm />;
}
